export default function (dom, opts) {
  var options = {
    classes: {
      showOverlay: 'contact-overlay',
      showLoginOverlay: 'login-overlay',
      showCrawlerOverlay: 'show--crawler',
      closeOverlay: 'close-box',
    },
    selectors: {
      toggleOverlay: '[data-contact]',
      toggleOverlayContact: '[data-contactelement]',
      toggleOverlayWidget: '[data-contact-widget]',
      toggleLoginOverlay: '[data-login]',
      toggleCrawlerOverlay: '[data-crawler-toggle]',
      closeCrawler: '[data-close-crawler]',
      toggleLogoutOverlay: '[data-logout]',
      boxClose: '[data-close-box]',
      productNameFormSel: '[name="productname"]',
      titleSel: '[data-product-offer-title]',
    },
    ...opts
  };

  const html = document.documentElement;
  const body = document.body;
  const toggleHandle = dom.querySelector("[data-toggle-handle]");

  init();

  function init() {
    // Wichtig: nur einmal global binden
    if (!window.__overlaytoggleBound) {
      window.__overlaytoggleBound = true;
      document.addEventListener('click', onDelegatedToggle);
    }

    const crawlerSelector = dom.querySelector(options.selectors.toggleCrawlerOverlay);
    if (crawlerSelector) crawlerSelector.addEventListener('click', toggleCrawlerOpen);

    const closeCrawlerBtn = document.querySelector(options.selectors.closeCrawler);
    if (closeCrawlerBtn) closeCrawlerBtn.addEventListener('click', closeCrawler);

    Array.from(document.querySelectorAll(options.selectors.boxClose)).forEach(el => {
      el.addEventListener('click', onClose);
    });

    if (toggleHandle) {
      toggleHandle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        onOpen();
      });
    }

    maybeAutoOpen();
  }

  function onDelegatedToggle(e) {
    const toggleTarget = e.target.closest(
      [
        options.selectors.toggleOverlay,
        options.selectors.toggleOverlayContact,
        options.selectors.toggleOverlayWidget
      ].join(', ')
    );
    if (!toggleTarget) return;

    e.preventDefault();
    e.stopPropagation();

    if (html.classList.contains(options.classes.showOverlay)) onClose();
    else onOpen();
  }

  function onOpen() { html.classList.add(options.classes.showOverlay); }

  function onClose() {
    html.classList.remove(options.classes.showOverlay);

    const productNameInForm = body.querySelector(options.selectors.productNameFormSel);
    if (productNameInForm) productNameInForm.value = '';

    const formTitle = body.querySelector(options.selectors.titleSel);
    if (formTitle) formTitle.innerHTML = formTitle.getAttribute('data-default-title') || '';

    html.classList.remove(options.classes.showLoginOverlay);
  }

  function toggleCrawlerOpen() { html.classList.toggle(options.classes.showCrawlerOverlay); }
  function closeCrawler() { html.classList.remove(options.classes.showCrawlerOverlay); }

  function getUrlParam(name) {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(name);
    if (value === null || value === '') return null;
    const num = parseInt(value, 10);
    return isNaN(num) ? null : num;
  }

  function maybeAutoOpen() {
    const hasGroupFromUrl = !!getUrlParam('contactGroupId');
    const hasContactFromUrl = !!getUrlParam('contactId');
    if (!hasGroupFromUrl && !hasContactFromUrl) return;

    if (typeof window.loadContacts === 'function') window.loadContacts();
    onOpen();

    const overlayContainer = document.querySelector('.contact-overlay-container');
    if (overlayContainer) overlayContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
